import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation toggleRequireSlaAgreement($id: String!) {
    toggleRequireSlaAgreement(id: $id) {
      id
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.MutationResponseState = {
  result: null,
  error: null,
  loading: false
};

export const toggleRequireSlaAgreementRequest = createAsyncThunk<
  TYPES.MutationResponse,
  {id: String;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'organization/toggle_require_sla_agreement',
  async (params: {id: String;}, { extra: client }) => {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.toggleRequireSlaAgreement;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const toggleRequireSlaAgreementSlice = createSlice({
  name: 'toggle_require_sla_agreement',
  initialState: initialState,
  reducers: {
    toggleRequireSlaAgreementClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(toggleRequireSlaAgreementRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(
      toggleRequireSlaAgreementRequest.fulfilled,
      (state, action) => {
        state.result = action.payload;
        state.loading = false;
      }
    ).
    addCase(
      toggleRequireSlaAgreementRequest.rejected,
      (state, action) => {
        state.error = action.payload as Error || {
          message: 'Failed to fetch',
          statusCode: '500'
        };
        state.loading = false;
      }
    );
  }
});

export const { toggleRequireSlaAgreementClear } =
toggleRequireSlaAgreementSlice.actions;

export const toggleRequireSlaAgreement = createSelector(
  (state: RootState) => state.organization.toggleRequireSlaAgreement.result,
  (state: RootState) => state.organization.toggleRequireSlaAgreement.error,
  (state: RootState) => state.organization.toggleRequireSlaAgreement.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default toggleRequireSlaAgreementSlice.reducer;